import { supabase } from '../lib/supabase';

export const getHomepageConfiguration = async () => {
  const { data, error } = await supabase
    .from('homepage_configuration')
    .select('*');

  if (error) {
    console.error('Error fetching homepage configuration:', error.message);
    return null;
  }
  return data;
};

export const updateHomepageComponent = async (id, updates) => {
  const { data, error } = await supabase
    .from('homepage_configuration')
    .update(updates)
    .eq('id', id)
    .select(); 

  if (error) {
    console.error(`Error updating homepage component with ID ${id}:`, error.message);
    return null;
  }
  console.log('Data returned from update:', data);
  return data;
};
